<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 21 15" style="enable-background:new 0 0 21 21;" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
<title>search</title>
        <desc>Created with Sketch.</desc>
        <g transform="translate(0,-952.36218)">
	<path d="M5,957.8c1.8,0,3.4,1,4.3,2.4h9.1c0.1,0,0.2,0,0.3,0.1l2.2,2c0.2,0.2,0.2,0.5,0,0.7l-2.9,2.4c-0.2,0.1-0.4,0.1-0.6,0l-1-1
		l-1,1c-0.2,0.2-0.5,0.2-0.6,0l-1-1l-1,1c-0.1,0.1-0.2,0.1-0.3,0.1H9.3c-0.9,1.4-2.5,2.4-4.3,2.4c-2.8,0-5-2.3-5-5
		C0.1,959.4,3,957.8,5,957.8L5,957.8z M5,958.7c-2.3,0-4.2,1.9-4.2,4.2S2.7,967,5,967c1.6,0,3-0.9,3.7-2.2c0.1-0.1,0.2-0.2,0.4-0.2
		h3.2l1.2-1.2c0.2-0.2,0.5-0.2,0.6,0l1,1l1-1c0.2-0.2,0.5-0.2,0.6,0l1,1l2.1-1.8l-1.7-1.5H9.1c-0.2,0-0.3-0.1-0.4-0.2
		C7.7,959.3,6.4,958.7,5,958.7z M3.5,961.1c1,0,1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8
		C1.7,961.9,2.5,961.1,3.5,961.1z M3.5,962c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9C4.4,962.4,4,962,3.5,962z"/>
</g>
</svg>
</template>

<script>
    export default {
        name: "OwnerIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
